var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.404 22.4037C4.66517 22.4037 0 17.7385 0 11.9997C0 6.26083 4.66517 1.59561 10.404 1.59561C13.0356 1.59561 15.5052 2.55142 17.4292 4.31511C16.7892 4.69352 16.1717 5.11269 15.5776 5.56639C14.1198 4.3903 12.3071 3.74275 10.404 3.74275C5.85588 3.74275 2.14714 7.45155 2.14714 11.9997C2.14714 16.5478 5.85588 20.2566 10.404 20.2566C16.7323 20.2566 20.4895 13.4921 17.7676 8.23269C18.1801 7.84907 18.6047 7.47724 19.0405 7.11782C19.1692 7.01168 19.299 6.90654 19.4296 6.80246C20.3402 8.37508 20.8083 10.1581 20.8083 11.9996C20.8081 17.7385 16.1429 22.4037 10.404 22.4037Z",
    fill: "#F6C415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6774 17.3481C10.5604 17.3481 10.4628 17.27 10.4237 17.1724C10.4042 17.1334 8.72547 12.8 6.12932 11.1603C5.6218 10.848 5.23148 10.5161 5.38761 9.77432C5.54374 9.0521 6.03178 8.64218 6.91013 8.44697C8.47169 8.11511 10.1504 10.5356 10.7751 11.5311C12.9613 8.34942 17.3337 3.35229 23.6971 2.7667C24.0041 2.73071 24.1176 3.18575 23.8338 3.31326C23.7362 3.35229 14.6399 7.51009 10.9506 17.192C10.8922 17.2895 10.7945 17.3481 10.6774 17.3481Z",
    fill: "#F6C415"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.390323e380db8d96e1fdaa7c25d30fbe.svg";
export { ForwardRef as ReactComponent };